import { BoxProps, Center, Spinner, Text } from "@chakra-ui/react";
import React from "react";
import zIndices from "theme/zIndices";

export interface FullScreenLoadingStateProps extends BoxProps {
  message?: string;
  gap?: number;
}

export const FullScreenLoadingState: React.FC<FullScreenLoadingStateProps> = ({
  message,
  gap,
  ...props
}) => (
  <Center
    flex={1}
    gap={gap || 8}
    flexDirection="column"
    data-ls-enabled={true}
    data-public={true}
    top={0}
    right={0}
    bottom={0}
    left={0}
    bg="gray.25"
    opacity={0.9}
    position="absolute"
    zIndex={zIndices.fullScreenLoadingState}
    {...props}
  >
    <Spinner size="xl" />
    {message && <Text>{message}</Text>}
  </Center>
);
